export default function serializePricing(pricing) {
  return {
    ...pricing,

    relative_amount: pricing.relative_amount && pricing.relative_amount.value,
    absolute_amount: pricing.absolute_amount && pricing.absolute_amount.value,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializePricing.js